import { render, staticRenderFns } from "./apiCodeTab.vue?vue&type=template&id=45e224d2&"
import script from "./apiCodeTab.vue?vue&type=script&lang=js&"
export * from "./apiCodeTab.vue?vue&type=script&lang=js&"
import style0 from "./apiCodeTab.vue?vue&type=style&index=0&id=45e224d2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports